import { render, staticRenderFns } from "./MerchantUserManage.vue?vue&type=template&id=4b8944b8&"
import script from "./MerchantUserManage.vue?vue&type=script&lang=ts&"
export * from "./MerchantUserManage.vue?vue&type=script&lang=ts&"
import style0 from "./MerchantUserManage.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports